
export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_dfDefinitionNo') || '标准编号',
    field: 'dfDefinitionNo',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dfDefinitionStatus') || '状态',
    field: 'dfDefinitionStatus',
    minWidth: 80,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dfDefinitionName') || '标准名称',
    field: 'dfDefinitionName',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '适用客户',
    field: 'custName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'displayCustomer' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_enableDate') || '启用日期',
    field: 'enableDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_disableDate') || '停用日期',
    field: 'disableDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_productScopeDescription') || '适用产品说明',
    field: 'productScopeDescription',
    minWidth: 200,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  }
]
